import { DialogContent, IconButton, Tab, Tabs, withStyles } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Visualizacao01 from "./Views/Visualizacao01";
import Visualizacao02 from "./Views/Visualizacao02";
import Visualizacao03 from "./Views/Visualizacao03";
import React from "react";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

const newState = {
    tabValue: 0
};
class GaleriaDialog extends XAPPComponent {

    state = { ...newState };

    handleChangeTab = (event, tabValue) => {
        this.setState({ tabValue });
    };


    render() {
        const { open, openDialog, xappRouteParams, selected } = this.props;
        const form = this.state;

        return (
            <XAPPDialog
                id="Galeria"
                open={open}
                onClose={() => openDialog(false)}
                fullWidth
                fullScreen
            >
                <div />
                <DialogContent
                    id="galeriaDialogContent"
                    className="p-0"
                >
                    <div className="flex w-full">
                        <Tabs
                            value={form.tabValue}
                            indicatorColor="secondary"
                            onChange={this.handleChangeTab}
                            textColor="secondary"
                            variant="scrollable"
                            scrollButtons="off"
                            classes={{
                                root: "h-32 w-full",
                                flexContainer: "justify-center"
                            }}
                        >
                            <Tab value={0} classes={{ root: "h-32" }} label="Visualizador" />
                            {selected !== null && selected.length === 2 &&
                                <Tab value={1} classes={{ root: "h-32" }} label="Comparação" />
                            }
                        </Tabs>
                        <div className="flex-1" />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6 px-16"
                            color="primary"
                            onClick={() => openDialog(false)}
                        >
                            <MdClose className="text-20" />
                        </IconButton>
                    </div>
                    {open && form.tabValue === 0 &&
                        <Visualizacao01 xappRouteParams={xappRouteParams} />
                    }
                    {open && form.tabValue === 1 &&
                        <Visualizacao02 xappRouteParams={xappRouteParams} />
                    }
                    {open && form.tabValue === 2 &&
                        <Visualizacao03 xappRouteParams={xappRouteParams} />
                    }
                </DialogContent>
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage
    }, dispatch);
}

function mapStateToProps({ Arquivo }) {
    return {
        selected: Arquivo.selected,
    };
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(GaleriaDialog)));
